import { Container } from "@mui/material"
import DataTable, { HeadCell, IDataTableId } from "../../../components/Misc/DataTable/DataTable"
import { useCallback, useContext, useEffect, useState } from "react"
import { useSnackbar } from "notistack";
import { NavigationContext } from "../../../Store/Navigation/context";
import { setLoading } from "../../../Store/Navigation/reducer";
import { APIsContext } from "../../../Store/APIs/context";
import { AdjudicationPending, AdjudicationPendingOperation } from "neurotec-megamatcherid-management-client-adjudicator";
import { IAdjudicationPendingFilter } from "../../../Store/Adjudication/types";
import DatatableFooter from "../../../components/Misc/DataTable/DatatableFooter";
import AdjudicationOverviewDialog from "../components/AdjudicationOverviewDialog";
import AdjudicationPendingFilter from "../../../components/Filter/AdjudicationPendingFilter";
import Authentication from "../../../Store/Authentication/AuthenticationStore";

const headCells: HeadCell[] = [
    {
        id: 'FILTER_ADJUDICATION_PENDING_DATE',
        align: 'left',
        disablePadding: false,
        label: 'Date',
        width: "30%"
    },
    {
        id: 'FILTER_ADJUDICATION_PENDING_UUID',
        align: 'left',
        disablePadding: false,
        label: 'Adjudication UUID',
        width: "45%"
    },
    {
        id: 'FILTER_ADJUDICATION_PENDING_ISSUES',
        align: 'left',
        disablePadding: false,
        label: 'Issues',
        width: "25%"
    },
];

const AdjudicationPendingTab: React.FC = () => {

    const { enqueueSnackbar } = useSnackbar();
    const navigationDispatch = useContext(NavigationContext).dispatch
    const apisState = useContext(APIsContext).state
    const [adjudicationsPending, setAdjudicationPending] = useState<AdjudicationPending[]>([])
    const [adjudicationsPendingCount, setAdjudicationPendingCount] = useState<number | undefined>(undefined);
    const [selected, setSelected] = useState<IDataTableId[]>([]);
    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(20)
    const [adjudicationPendingFilter, setAdjudicationPendingFilter] = useState<IAdjudicationPendingFilter>({})
    const [selectedAdjudication, setSelectedAdjudication] = useState<AdjudicationPendingOperation>();
    const [showPendingDialog, setShowPendingDialog] = useState(false)

    const fetchAdjudicationPending = useCallback(async () => {
        try {
            navigationDispatch(setLoading(true))
            apisState.AdjudicationApi.getAdjudicationsPending({page: page, size: perPage, ...adjudicationPendingFilter}).then(res => {
                setAdjudicationPending(res.data)
                navigationDispatch(setLoading(false))
            }).catch(e => {
                console.log(e)
                enqueueSnackbar(e.message, {variant: "error"})
                navigationDispatch(setLoading(false))
            })

            apisState.AdjudicationApi.getAdjudicationsPendingCount(adjudicationPendingFilter).then(res => {
                setAdjudicationPendingCount(res.data)
            }).catch(e => {
                setAdjudicationPendingCount(0)
                console.log(e)
                enqueueSnackbar(e.message, {variant: "error"})
            })
        } catch (error: any) {
            console.log(error)
            enqueueSnackbar(error.message, {variant: "error"})
        }
    }, [page, perPage, apisState.AdjudicationApi, adjudicationPendingFilter, enqueueSnackbar, navigationDispatch])

    useEffect(() => {
        fetchAdjudicationPending();
    }, [apisState.AdjudicationApi, adjudicationPendingFilter, page, perPage, fetchAdjudicationPending])


    const handleAdjudicationClick = (adjudication: AdjudicationPending) => {
        if (adjudication && adjudication.uuid) {
            apisState.AdjudicationApi.getAdjudicationPending({uuid: adjudication.uuid}).then(res => {
                setSelectedAdjudication(res.data)
                setShowPendingDialog(true)
            }).catch(e => {
                setSelectedAdjudication(undefined)
                enqueueSnackbar(e.message, {variant: "error"})
            })
        }
    }

    const handlePageChange = (event: React.ChangeEvent<unknown> | undefined, newPage: number) => {
        setPage(newPage)
    }
    
    const handleFilterChange = (filter: IAdjudicationPendingFilter) => {
        setPage(1)
        setAdjudicationPendingCount(undefined)
        setAdjudicationPendingFilter(filter)
    }

    const handleSolveReload = () => {
        enqueueSnackbar("Adjudication solved", {variant: "info"})
        fetchAdjudicationPending()
    }

    return (
        <>
        <Container maxWidth="xl" sx={{ display: "flex", flexDirection: "column" }} >
            <AdjudicationPendingFilter
                filter={adjudicationPendingFilter}
                onFilterApply={handleFilterChange}
            />
            <DataTable
                data={adjudicationsPending}
                filter={adjudicationPendingFilter}
                onFilterChange={handleFilterChange}
                headCells={headCells}
                title={"Pending adjudications"}
                dateName={"date"}
                setSelected={setSelected}
                selected={selected}
                type="adjudication-pending"
                onRowClick={handleAdjudicationClick}
            />
            <DatatableFooter
                page={page}
                handlePageChange={handlePageChange}
                count={adjudicationsPendingCount}
                perPage={perPage}
                setPerPage={setPerPage}
                label='Adjudications'
            />
        </Container>
        {selectedAdjudication &&
        (<AdjudicationOverviewDialog
            decisions={Authentication.isAdminAuthenticated()}
            open={showPendingDialog}
            onClose={() => setShowPendingDialog(false)}
            adjudication={selectedAdjudication}
            reload={handleSolveReload}
        />)}
        </>
    )
}

export default AdjudicationPendingTab